import { render, staticRenderFns } from "./FormStaticTextField.vue?vue&type=template&id=0118d07e"
import script from "./FormStaticTextField.vue?vue&type=script&lang=ts"
export * from "./FormStaticTextField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports